var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 84",
    style: {
      enableBackground: "new 0 0 84 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0F6FF;}\n\t.st1{fill:#355D8B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8823",
    transform: "translate(-920.125 -323.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8553",
    transform: "translate(920.125 323.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_192",
    className: "st0",
    d: "M42,0L42,0c23.2,0,42,18.8,42,42l0,0c0,23.2-18.8,42-42,42l0,0C18.8,84,0,65.2,0,42l0,0 C0,18.8,18.8,0,42,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8822",
    transform: "translate(946.436 349.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8821",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8819",
    transform: "translate(10.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8815",
    transform: "translate(1.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8813",
    transform: "translate(0 0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4393",
    className: "st1",
    d: "M1.4,16.4C0.6,16.4,0,15.7,0,15c0-0.4,0.1-0.7,0.4-1L14,0.4c0.5-0.5,1.4-0.5,1.9,0 c0.5,0.5,0.5,1.4,0,1.9L2.3,16C2.1,16.2,1.7,16.4,1.4,16.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8812",
    transform: "translate(4.09 4.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4394",
    className: "st1",
    d: "M1.4,16.4C0.6,16.4,0,15.7,0,15c0-0.4,0.1-0.7,0.4-1L14,0.4c0.5-0.5,1.4-0.5,1.9,0 s0.5,1.4,0,1.9L2.3,16C2.1,16.2,1.7,16.4,1.4,16.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8814",
    transform: "translate(13.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    className: "st1",
    d: "M5.5,6.9c-0.8,0-1.4-0.6-1.4-1.4c0-0.1,0-0.1,0-0.2C4.2,4.6,4,3.8,3.6,3.2 C3,2.8,2.3,2.6,1.5,2.7C0.8,2.8,0.1,2.3,0,1.5C0,0.8,0.5,0.2,1.2,0c1.6-0.2,3.2,0.2,4.4,1.3c1,1.2,1.4,2.8,1.2,4.3 C6.7,6.4,6.1,6.8,5.5,6.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    transform: "translate(0 13.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4396",
    className: "st1",
    d: "M1.4,8.2C0.6,8.2,0,7.6,0,6.8c0-0.1,0-0.2,0-0.3L1.4,1c0.2-0.7,0.9-1.2,1.7-1 S4.2,1,4,1.7l0,0L3.2,4.9l3.2-0.8C7.2,4,8,4.4,8.1,5.1c0.2,0.7-0.3,1.4-1,1.6L1.7,8.1C1.6,8.2,1.5,8.2,1.4,8.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8820",
    transform: "translate(0 2.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    className: "st1",
    d: "M28.6,30H1.4C0.6,30,0,29.4,0,28.6l0,0V1.4C0,0.6,0.6,0,1.4,0h15c0.8,0,1.4,0.6,1.4,1.4 c0,0.8-0.6,1.4-1.4,1.4H2.7v24.5h24.5V13.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v15C30,29.4,29.4,30,28.6,30z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.b57265628cb21cd5ee56369253a3fe36.svg";
export { ForwardRef as ReactComponent };